import { IconProps } from './index';

const ArrowDownLine: React.VFC<IconProps> = ({ title, titleId, ...props }) => {
    return (
        <svg
            width="11"
            height="12"
            viewBox="0 0 11 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-labelledby={titleId}
            {...props}
        >
            {title && <title id={titleId}>{title}</title>}
            <path
                d="M6.23579 8.78166L9.81179 5.20566L10.7545 6.14833L5.56912 11.3337L0.383789 6.14833L1.32646 5.20566L4.90246 8.78166V0.666992H6.23579V8.78166Z"
                fill="white"
            />
        </svg>
    );
};

export default ArrowDownLine;
